import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { QRCodeSVG } from "qrcode.react";
import { db } from "../firebase";
import { isItemActive, sortItemsByEndDate } from "../lib/auctions";

const AUCTION_BASE_URL = "https://auction.lepingouin.be";

export default function QRCodes() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "items"), (snapshot) => {
      const allItems = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const activeItems = allItems.filter((item) => isItemActive(item));
      setItems(sortItemsByEndDate(activeItems));
    });

    return unsubscribe;
  }, []);

  return (
    <div className="min-h-screen bg-orange-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-center text-orange-700 mb-3">
          QR Codes Des Encheres
        </h1>
        <p className="text-center text-gray-700 mb-8">
          Chaque QR code pointe vers la page de l&apos;article correspondant.
        </p>

        {items.length === 0 ? (
          <p className="text-center text-gray-600">
            Aucune enchere active disponible.
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {items.map((item) => {
              const itemUrl = `${AUCTION_BASE_URL}/item/${item.slug}`;

              return (
                <div
                  key={item.id}
                  className="bg-white rounded-xl shadow p-6 border border-orange-100 flex flex-col items-center text-center"
                >
                  <h2 className="text-xl font-semibold mb-4">{item.name}</h2>
                  <QRCodeSVG value={itemUrl} size={220} level="Q" />
                  <p className="mt-4 text-sm text-gray-700 break-all">
                    {itemUrl}
                  </p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
